import React, { useCallback, useMemo, useRef, useState } from 'react'

import PageWrapper from '@Layout/PageWrapper'
import Layout      from '@Layout/BackOffice'

import PrivateSaleRow from '@/Lists/Rows/PrivateSaleRow'
import Dashboard      from '@/Lists/Dashboard'

import SearchBar from '@Pure/SearchBar'
import Link      from '@Pure/Link'

const DASHBOARD = 'PrivateSaleList';

const sortable_columns =
[
	'date'
];

const header =
[
	{
		label: 'Date', name: 'date'
	},
	{
		label: 'Nom', name: 'title'
	},
	{
		label: '', name: 'actions'
	}
]
.map(opt => ({ ...opt, sortable: sortable_columns.includes(opt.name) }));

const fields = header.map(data => data.name);

const fields_with_timeout =
[
	'searched'
];

const storage_filters =
{
	searched: window.localStorage.getItem(DASHBOARD + '.searched') || ''
};

const NO_STATUS = { };

export default PageWrapper(function PrivateSaleList (props)
{
	const search_timeout = useRef();
	
	const [instant_filters, setInstantFilters] = useState({ ...storage_filters });
	const [delayed_filters, setDelayedFilters] = useState({ ...storage_filters });

	const handleChange = useCallback(function ({ value, e, name })
	{
		if (!name) return;

		if (e === null && fields_with_timeout.includes(name) === false) return;

	// Prevent on mount trigger
		if (e === null && fields_with_timeout.includes(name)) return;

		window.localStorage.setItem(DASHBOARD + '.' + name, value);

		setInstantFilters(function (filters)
		{
			return { ...filters, [name]: value };
		});

		if (fields_with_timeout.includes(name) === false) return;

		if (search_timeout.current)
		{
			window.clearTimeout(search_timeout.current);
		}

		search_timeout.current = window.setTimeout(function ()
		{
			search_timeout.current = undefined;

			setDelayedFilters(function (filters)
			{
				return { ...filters, [name]: value };
			});
		},
		320);
	},
	[]);

	const handleSearchChange = useCallback(function (value, data={ }, e)
	{
		handleChange({ value: value, name: data?.name, e });
	},
	[handleChange]);

	const handleNativeChange = useCallback(function (e)
	{
		handleChange({ value: e?.target?.value, name: e?.target?.name, e });
	},
	[]);

	const filters = useMemo(function ()
	{
		const filters =
		{
			searched: delayed_filters.searched
		};

		return filters;
	},
	[instant_filters, delayed_filters]);
	
	return (
		<Layout page_title="Ventes Privées" history={ props.history }>

			<div className="page-content">

				<div className="o-grid-4 u-flex-wrap u-content-between
					u-margin-bottom-15 u-items-end">

					<div className="o-grid__item">
						<SearchBar hide_btn={ true }
							placeholder="Nom"
							handleChange={ handleSearchChange }
							value={ instant_filters.searched }
							name="searched"
							className="c-searchbar c-searchbar--dashboard"
						/>
					</div>

					<div className="o-grid__item">
						<Link href="/gestion-des-ventes-privees/nouvelle"
							className="c-btn c-btn--add u-no-margin-top">
							Nouvelle Vente Privée
						</Link>
					</div>

				</div>

				<div className="o-content">
					<Dashboard model="PrivateSale" items-per-page={ 50 }
						url="/dashboard/private-sales" filters={ filters }
						header={ header } fields={ fields }
						order="DESC" order-by="date"
						disable-sort={ filters.searched ? true : false }
						component={ PrivateSaleRow }
					/>
				</div>

			</div>

		</Layout>
	);
});